import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { CreditsState } from './Credits.state';
import { useCommon } from 'src/domains/common/Common';
import {
    CreditsCardContainer,
    CreditsTabContainer,
    CreditsTotalContainer,
    CreditsTotalValue,
    GiftIconStyled,
    NoCreditsText,
    RewardIconStyled,
} from './Credits.style';
import { FiltersNewView } from 'src/domains/layouts/webview/components/filters/Filters';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { CreditsBetSpinsCard } from './CreditsBetSpinsCard';
import { CreditsBonusBalanceCard } from './CreditsBonusBalanceCard';
import { useAppStateContext } from 'src/appState/AppState';

export const Credits = observer('Credits', () => {
    const common = useCommon();
    const appState = useAppStateContext();
    const { getGameModelByLaunchGameId } = appState.appPlayersState.callbacks;

    const [creditsState] = useState(() => new CreditsState(common));
    const config = ConfigComponents.get(common);
    const bonusesData = creditsState.bonuses === 'loading' ? 'loading' : creditsState.bonuses ?? null;
    const shouldShowEmptyMessage =
        bonusesData !== 'loading' &&
        (bonusesData?.data?.length === 0 || bonusesData === null || bonusesData.data === null);
    return (
        <CreditsTabContainer>
            <FiltersNewView
                select={creditsState.creditType}
                filters={creditsState.filters}
                skin={config.config.filtersVersion.credits}
            />
            <CreditsTotalContainer>
                <span>
                    <I18n
                        langKey='account.credits.total'
                        defaultText='Available:'
                    />
                </span>
                <CreditsTotalValue>
                    {creditsState.creditType === 'free-bets' ? <GiftIconStyled /> : null}
                    {creditsState.creditType === 'free-spins' ? <RewardIconStyled /> : null}
                    {creditsState.getTotalValue}
                </CreditsTotalValue>
            </CreditsTotalContainer>
            {bonusesData === 'loading' ? null : (
                <CreditsCardContainer>
                    {bonusesData?.type === 'bet/spins'
                        ? bonusesData.data?.map((bonus) => (
                              <CreditsBetSpinsCard
                                  key={bonus.bonusId}
                                  bonus={bonus}
                                  creditsState={creditsState}
                                  getGameModelByLaunchGameId={getGameModelByLaunchGameId}
                              />
                          ))
                        : null}

                    {bonusesData?.type === 'bonusBalance'
                        ? bonusesData.data?.map((bonus) => (
                              <CreditsBonusBalanceCard
                                  bonus={bonus}
                                  creditsState={creditsState}
                                  key={bonus.bonusId}
                                  getGameModelByLaunchGameId={getGameModelByLaunchGameId}
                              />
                          ))
                        : null}
                    {shouldShowEmptyMessage ? <NoCreditsText>You don’t have any free credits yet</NoCreditsText> : null}
                </CreditsCardContainer>
            )}
        </CreditsTabContainer>
    );
});
